import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';
import ArrowDropUpIcon from '@mui/icons-material/ArrowDropUp';
import { LinearProgress, Menu, Stack } from '@mui/material';
import Step from '/@/components/bayer/step';
import { useAnchorEl } from '/@/hooks/anchor-el/useAnchorEl';
import type { StepProps } from '/@/types/bayer/step';

function ProgressSidebar({ steps, activeStep }: { steps: StepProps[]; activeStep: number }) {
    const [{ open, anchorEl }, { handleClick, handleClose }] = useAnchorEl();
    return (
        <>
            <Stack>
                <Step
                    key={steps[activeStep].name}
                    index={steps[activeStep].index}
                    active={true}
                    name={steps[activeStep].name}
                    caption={steps[activeStep]?.caption}
                    onClick={handleClick}
                    isSidebarHeader
                    sidebarHeaderIcon={anchorEl ? <ArrowDropUpIcon /> : <ArrowDropDownIcon />}
                />
                <LinearProgress variant='determinate' value={(steps[activeStep].index / steps.length) * 100} />
            </Stack>
            <Menu
                id='steps-menu'
                anchorEl={anchorEl}
                open={open}
                onClose={handleClose}
                MenuListProps={{
                    sx: { p: 0 },
                }}
                slotProps={{ paper: { sx: { width: '100%' } } }}
            >
                {steps.map((step, i) => (
                    <Step
                        key={step.name}
                        index={step.index}
                        active={step.active}
                        name={step.name}
                        caption={step?.caption}
                        subSteps={step?.subSteps}
                        summary={step?.summary}
                        disabled={step?.disabled}
                        onClick={() => {
                            step.onClick?.();
                            handleClose();
                        }}
                    />
                ))}
            </Menu>
        </>
    );
}

export default ProgressSidebar;
